import { BacktestingPortfolioValuesData } from 'scenes/report/types';
import { MapBacktestingPortfolioValueOptions } from 'shared/components/DataGrid/BacktestingExceptionsGrid/types';

export const mapBacktestingPortfolioValueGrid = ({
  fundMeasureList,
}: MapBacktestingPortfolioValueOptions): BacktestingPortfolioValuesData[] => {
  return fundMeasureList.map(({ name }, index) => ({
    name,
    value: name === 'Global Bond Fund' ? '6' : `${index}`,
  }));
};
